// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1PU4h","icon":"_3OWSt","clear":"_40NTr"};